import Vue from 'vue'
import Vuex, { createNamespacedHelpers } from 'vuex'

import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

const name = 'preview'

const namespace = type => `${name}/${type}`

const {
    mapState,
    mapActions,
    mapGetters,
    mapMutations,
} = createNamespacedHelpers(name)

const store = new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    modules: {
        [name]: {
            namespaced: true,
            state,
            mutations,
            actions,
            getters,
        },
    },
})

export {
    namespace,
    mapState,
    mapActions,
    mapGetters,
    mapMutations,
}

export default store
